import { NavLink, useParams } from 'react-router-dom';
import { useEffect } from 'react'

const Gallery = () => {
  return(
    <div className='gallery-holder'>
      <div className='pair-gallery'>
        <div className='img-holder'><img src="../../assets/photography/apc/02900029.jpg" alt="" /></div>
        <div className='img-holder'><img src="../../assets/photography/apc/02900031.jpg" alt="" /></div>
        <div className='img-holder'><img src="../../assets/photography/apc/02890014.jpg" alt="" /></div>
      </div>
    </div>
  )
}
const Description = () => {
  return(
    <div className="article-holder">
      <p>Hydroelectric power plants and their lakes on Drava river in North West Croatia. General idea is to make a documentation on anthropocene traces near me. I still see it as a work in progress.</p>
    </div>
  )
}

export const APC = () => {
  const { id } = useParams();
  
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="project-detail-page">
      <h1>• APC •</h1>
      <nav>
        <ul>
          <li><NavLink to="/photography/apc/gallery">Gallery</NavLink><span>,&nbsp;</span></li>
          <li><NavLink to="/photography/apc/description">Description</NavLink></li>
        </ul>
      </nav>
      {(id === 'gallery' ? <Gallery /> : <Description />)}
    </div>
  )
}